import { GAME_LABEL_TYPE } from "constants/game.constants";
import FavoriteResourceSortingContext from "contexts/favoriteResourceSortingContext";
import useAppSelector from "hooks/store/useAppSelector";
import { useContext, useMemo } from "react";
import { selectSessionGames } from "store/slices/auth/selectors";
import { binaryToFlags } from "utils/binaryCalculations";

const gameLabelValues = Object.values(GAME_LABEL_TYPE)

const useGameSortingByFavorite = () => {
	const games = useAppSelector(selectSessionGames);
	const { favoriteGames: favoriteGamesSortingOrdersMap } = useContext(FavoriteResourceSortingContext)
	const sortedGames = useMemo(() => {
		const gamesWithNewLabel = [];
		const gamesWithoutNewLabel = [];
		games.forEach(game => {
			if (binaryToFlags(gameLabelValues, game.gameLabel).includes(GAME_LABEL_TYPE.NEW)) {
				gamesWithNewLabel.push(game)
			} else {
				gamesWithoutNewLabel.push(game)
			}
		})
		const sortCallback = (nextGame, prevGame) => {
			const nextGameCount = favoriteGamesSortingOrdersMap[nextGame.type] ?? 0;
			const prevGameCount = favoriteGamesSortingOrdersMap[prevGame.type] ?? 0;
			return prevGameCount - nextGameCount;
		}
		return [
			...gamesWithNewLabel.sort(sortCallback),
			...gamesWithoutNewLabel.sort(sortCallback)
		]
	}, [games, favoriteGamesSortingOrdersMap]);
	return sortedGames;
};


export default useGameSortingByFavorite;